import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=c16638aa"
import script from "./Datatables.vue?vue&type=script&lang=js"
export * from "./Datatables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports